import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("barlow_token") || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function hydrate() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        if (active) setUser(res.data);
      } catch {
        localStorage.removeItem("barlow_token");
        if (active) {
          setToken(null);
          setUser(null);
        }
      } finally {
        if (active) setLoading(false);
      }
    }
    hydrate();
    return () => {
      active = false;
    };
  }, [token]);

  const persist = (data) => {
    localStorage.setItem("barlow_token", data.token);
    setUser(data.user);
    setToken(data.token);
  };

  const login = async (email, password) => {
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      persist(res.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "error" };
    }
  };

  const register = async (payload) => {
    try {
      const res = await axios.post(`${API}/auth/register`, payload);
      persist(res.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "error" };
    }
  };

  const logout = () => {
    localStorage.removeItem("barlow_token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
